<template>
  <div>
    <!-- <register-modal v-if="user.practice.status !== 1 && user.force_password_change" /> -->
    <confirm-practice-modal
      v-if="
        (user.practice.status !== 1 && user.force_password_change) ||
        !user.practice.is_setup_complete ||
        !user.practice.phone ||
        !user.practice.address
      "
    />
    <ViewingExampleReferralModal
      v-else-if="$route.name === 'referral-view' && $route.query.e && $route.query.e === $route.params.id"
    />
    <upsell-modal v-if="!user.practice.is_public" />
    <referral-tour v-if="activeTour" :name="activeTour" />
    <sms v-if="$store.getters['sms/isVisible']" />
  </div>
</template>

<script>
// import RegisterModal from '@/components/_layout/RegisterModal'
// import Calendly from '@/components/shared/Calendly'
import ConfirmPracticeModal from '@/components/_layout/ConfirmPracticeModal'
import ViewingExampleReferralModal from '@/components/_layout/ViewingExampleReferralModal'
import UpsellModal from '@/components/_layout/UpsellModal.WithBilling'
import { mapState, mapGetters } from 'vuex'
import ReferralTour from '@/components/referrals/ReferralTour'
export default {
  components: {
    // RegisterModal,
    ConfirmPracticeModal,
    ViewingExampleReferralModal,
    ReferralTour,
    UpsellModal,
    Sms: () => import('@/components/_layout/Sms'),
    // Calendly,
  },
  computed: {
    ...mapState('auth', ['user']),
    ...mapGetters('auth', ['isLoggedIn']),
    // ...mapState('settings', ['isPaymentModalVisible', 'isBannerVisible']),
    ...mapState('tour', ['activeTour']),
  },
}
</script>

<style>
</style>